@if (servicingFacilityData) {
  <div>
    <p-panel header="Servicing Facility Details" [toggleable]="true" [collapsed]="isPASComplete" toggler="header">
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
        @if (isActive) {
          <div class="p-field-checkbox-container p-field-checkbox mb-4">
            <p-checkbox
              data-test-id="different-facility-checkbox"
              [ngModel]="true"
              [binary]="true"
              [disabled]="true"
            ></p-checkbox>
            <label data-test-id="different-facility-label"> Different Servicing Facility </label>
          </div>
        }
        @if (servicingFacilityData.provider) {
          <div>
            <servicing-facility-panel-info
              [providerAccountDTO]="servicingFacilityData.provider.servicingProviderPgpsDTO"
              [tenantName]="tenantName"
              [isGoldCardVisible]="isGoldCardVisible"
              >
            </servicing-facility-panel-info>
          </div>
        }
        @if (!servicingFacilityData.provider) {
          <div>
            <servicing-facility-new-panel
              [servicingFacilityNewData]="servicingFacilityData"
              >
            </servicing-facility-new-panel>
          </div>
        }
        <div class="mt-4">
          <servicing-facility-panel-immediate
            [immediateContactDetails]="servicingFacilityData.facilityContact"
            [isInternal]="isInternal"
            >
          </servicing-facility-panel-immediate>
        </div>
    </p-panel>
  </div>
}
